import React from 'react';
import { useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';

import ListPage from '../../../sharedModules/listPage/ListPage';

import { titleize } from '../../../utils/titleize';

const waterAuthorityColumns = [
  {
    name: 'Water Authority',
    selector: 'name',
    sortable: true,
    sortDirection: 'asc',
    grow: 2,
  },
  {
    name: 'Contact Email',
    selector: 'contact_email',
    sortable: true,
    grow: 1,
  },
  {
    name: 'Submission Method',
    selector: 'submission_method',
    sortable: true,
    cell: (row) => <p>{titleize(row.submission_method)}</p>,
  },
  {
    name: 'PDF Template',
    selector: 'pdf_template_url',
    cell: (row) =>
      row.pdf_template_url && (
        <a href={row.pdf_template_url} target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            <Visibility />
          </Button>
        </a>
      ),
  },
];

const CreateButton = () => {
  const history = useHistory();

  return (
    <Grid container justifyContent="flex-end">
      <Button variant="contained" color="primary" onClick={() => history.push('/backflows/water_authorities/new')}>
        Add Water Authority
      </Button>
    </Grid>
  );
};

const WaterAuthorityListPage: React.FC = () => {
  return (
    <ListPage
      beforeComponent={<CreateButton />}
      clickableRows
      columns={waterAuthorityColumns}
      controller="backflows/water_authorities"
      title="Backflows"
      subtitle="Water Authority Config"
    />
  );
};

export default WaterAuthorityListPage;
